// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"20eb6f1f","553":"ae495b41","977":"4e101847"}[chunkId] + ".chunk.js";
};